export default "__VITE_ASSET__BiZaZuVl__ 400w, __VITE_ASSET__DPSSIvBp__ 800w, __VITE_ASSET__apfPfnui__ 1024w";